import { Construction } from 'lucide-react';

import { Card, PageHeader } from '@/components/ui';

/**
 * Consistent shell for admin screens whose feature phase has not landed yet.
 *
 * Better than a 404: the navigation reflects the finished information
 * architecture, and each screen states exactly which phase delivers it rather
 * than pretending to be functional.
 */
export function PlaceholderPage({
  title,
  description,
  phase,
}: {
  title: string;
  description: string;
  phase: string;
}) {
  return (
    <>
      <PageHeader title={title} description={description} />

      <Card className="px-6 py-16 text-center">
        <span className="mx-auto mb-4 grid size-12 place-items-center rounded-full bg-canvas">
          <Construction className="size-6 text-ink-subtle" aria-hidden="true" />
        </span>
        <p className="font-semibold text-ink">Arrives in {phase}</p>
        <p className="mx-auto mt-1 max-w-md text-sm text-ink-subtle">
          This screen needs authenticated admin APIs. The navigation and layout are in place so the
          information architecture is settled before the endpoints land.
        </p>
      </Card>
    </>
  );
}
